import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Layout, Row, Col, Tabs, List } from "antd";
import {
  listCollections,
  listUserPortfolios,
  removeUserPortfolio,
  addUserPortfolio,
} from "../../store/slices/superUser.slice";
import SuperUserTable from "./components/SuperUserTable";
import PageHeader from "../../components/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";


const { Content } = Layout;
const { TabPane } = Tabs;

const SuperUser = () => {
  const dispatch = useDispatch();
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Extracting state from the store
  const { userList, portfolioList, userPortfolios, status } = useSelector((state) => state.superuser);

  // Fetch collections (users or portfolios) on component mount
  useEffect(() => {
    dispatch(listCollections('users'));
    dispatch(listCollections('portfolios'));
    // You might want to also fetch other collection types as needed
  }, [dispatch]);

  // Fetch user portfolios when a user is selected
  useEffect(() => {
    if (selectedUserId) {
      dispatch(listUserPortfolios(selectedUserId));
    }
  }, [selectedUserId, dispatch]);


  return (
    <Layout>
      <PageHeader title={'SuperUser'} logoUrl={iconMapping.superUser}  />
      <Content style={{ padding: '50px' }}>
        <Row gutter={16} justify={'center'}>
          <Col span={20}>
            <Card title="Users" bordered={false}>
              <SuperUserTable userList={userList} portfolioList={portfolioList} />
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default SuperUser;
